var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, select, take, takeEvery, takeLatest } from 'redux-saga/effects';
import getConfig from '../config';
import * as actions from '../constants/actionTypes';
import { paymentPlanMap } from '../constants/payment';
import callApi from '../graphql/callApi';
import { PackageType, PaymentPlan, PaymentStatus, PlanStatus, TripStatus, TripType, } from '../graphql/generated/api';
import { getUserAddressId, getUserData } from '../selectors/user';
import { Plan } from '../type/pickups';
import sagaFactory from '../utils/sagaFactory';
var config = getConfig();
export function schedulePickup(_a) {
    var savedAddress, userData, addressId, shouldRefreshUser, resAddress, paymentStatus_1, resPickup_1, packages, clientSecret, paymentIntent, subscription, makePaymentResp, err_1, message;
    var _this = this;
    var _b, _c, _d, _e, _f, _g;
    var payload = _a.payload, next = _a.next;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                _h.trys.push([0, 32, , 34]);
                return [4 /*yield*/, select(getUserAddressId)];
            case 1:
                savedAddress = _h.sent();
                return [4 /*yield*/, select(getUserData)];
            case 2:
                userData = _h.sent();
                addressId = payload.addressId || savedAddress;
                shouldRefreshUser = !(payload.paymentMethodId || ((_b = payload === null || payload === void 0 ? void 0 : payload.paymentMethod) === null || _b === void 0 ? void 0 : _b.id));
                if (paymentPlanMap[userData.paymentPlan] !== payload.plan) {
                    shouldRefreshUser = true;
                }
                if (!!addressId) return [3 /*break*/, 6];
                return [4 /*yield*/, call(callApi.createAddress, {
                        name: payload.pickupDetails.name,
                        phone: payload.pickupDetails.phone,
                        street: payload.pickupDetails.street,
                        unit: payload.pickupDetails.unit,
                        city: payload.pickupDetails.city,
                        state: payload.pickupDetails.state || '',
                        zipCode: payload.pickupDetails.zipCode,
                        instructions: payload.pickupDetails.instructions || '',
                        nickname: '',
                        isDefault: true,
                    })];
            case 3:
                resAddress = _h.sent();
                if (!((_d = (_c = resAddress.data) === null || _c === void 0 ? void 0 : _c.createAddress) === null || _d === void 0 ? void 0 : _d.id)) return [3 /*break*/, 5];
                addressId = resAddress.data.createAddress.id;
                return [4 /*yield*/, put({
                        type: actions.saveAddressId.type.SUCCESS,
                        payload: resAddress.data.createAddress.id,
                    })];
            case 4:
                _h.sent();
                _h.label = 5;
            case 5:
                shouldRefreshUser = true;
                _h.label = 6;
            case 6:
                if (payload.plan === Plan.MEMBERSHIP) {
                    paymentStatus_1 = PaymentStatus.PAID;
                }
                else {
                    if (payload.amount === 0) {
                        paymentStatus_1 = PaymentStatus.FREE;
                    }
                    else {
                        paymentStatus_1 = PaymentStatus.UNPAID;
                    }
                }
                return [4 /*yield*/, call(callApi.createTrip, {
                        input: {
                            type: TripType.PICKUP,
                            method: payload.method,
                            addressId: addressId || '',
                            date: payload.pickupDate,
                            status: TripStatus.PENDING,
                            source: payload.source || null,
                            createdBy: payload.createdBy || null,
                        },
                    })];
            case 7:
                resPickup_1 = _h.sent();
                if (!((_f = (_e = resPickup_1.data) === null || _e === void 0 ? void 0 : _e.createTrip) === null || _f === void 0 ? void 0 : _f.id)) return [3 /*break*/, 31];
                return [4 /*yield*/, Promise.all(payload.packages.map(function (pack) { return __awaiter(_this, void 0, void 0, function () {
                        var resPackage;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, callApi.createPackage({
                                        input: __assign(__assign({ tripId: resPickup_1.data.createTrip.id, labelType: pack.type, type: PackageType.PICKUP, paymentStatus: paymentStatus_1 }, (pack.url ? { labelUrl: pack.url } : {})), { description: pack.description, source: payload.source || null, createdBy: payload.createdBy || null, date: payload.pickupDate }),
                                    })];
                                case 1:
                                    resPackage = _a.sent();
                                    return [2 /*return*/, resPackage];
                            }
                        });
                    }); }))];
            case 8:
                packages = _h.sent();
                if (!packages.some(function (val) { return !val; })) return [3 /*break*/, 10];
                return [4 /*yield*/, call(callApi.deleteTrip, { id: resPickup_1.data.createTrip.id })];
            case 9:
                _h.sent();
                throw new Error('Something went wrong, try aging later');
            case 10:
                clientSecret = '';
                if (!(payload.plan === Plan.PER_PICKUP)) return [3 /*break*/, 16];
                if (!(payload.amount !== 0)) return [3 /*break*/, 15];
                return [4 /*yield*/, put({
                        type: actions.getPaymentIntent.type.REQUEST,
                        payload: {
                            amount: payload.amount,
                        },
                    })];
            case 11:
                _h.sent();
                return [4 /*yield*/, take([
                        actions.getPaymentIntent.type.SUCCESS,
                        actions.getPaymentIntent.type.FAILED,
                    ])];
            case 12:
                paymentIntent = _h.sent();
                if (!(paymentIntent.type === actions.getPaymentIntent.type.FAILED)) return [3 /*break*/, 14];
                return [4 /*yield*/, call(callApi.deleteTrip, { id: resPickup_1.data.createTrip.id })];
            case 13:
                _h.sent();
                throw new Error(paymentIntent.payload);
            case 14:
                clientSecret = paymentIntent.payload.clientSecret;
                _h.label = 15;
            case 15: return [3 /*break*/, 22];
            case 16:
                if (!(userData.paymentPlan !== PaymentPlan.SUBSCRIPTION &&
                    payload.plan === Plan.MEMBERSHIP)) return [3 /*break*/, 21];
                return [4 /*yield*/, put({
                        type: actions.createSubscription.type.REQUEST,
                        payload: {
                            priceId: config.subscriptionPriceId,
                            promoCodeId: payload.promoId,
                        },
                    })];
            case 17:
                _h.sent();
                return [4 /*yield*/, take([
                        actions.createSubscription.type.SUCCESS,
                        actions.createSubscription.type.FAILED,
                    ])];
            case 18:
                subscription = _h.sent();
                if (!(subscription.type === actions.createSubscription.type.FAILED)) return [3 /*break*/, 20];
                return [4 /*yield*/, call(callApi.deleteTrip, { id: resPickup_1.data.createTrip.id })];
            case 19:
                _h.sent();
                throw new Error(subscription.payload);
            case 20:
                clientSecret = subscription.payload.clientSecret;
                return [3 /*break*/, 22];
            case 21:
                if (userData.planStatus !== PlanStatus.ACTIVE) {
                    throw new Error('Something go wrong with payment');
                }
                _h.label = 22;
            case 22:
                if (!clientSecret) return [3 /*break*/, 26];
                return [4 /*yield*/, put({
                        type: actions.makePayment.type.REQUEST,
                        payload: {
                            cardElement: payload.cardElement,
                            clientSecret: clientSecret,
                            paymentMethodId: payload.paymentMethodId || ((_g = payload === null || payload === void 0 ? void 0 : payload.paymentMethod) === null || _g === void 0 ? void 0 : _g.id),
                        },
                    })];
            case 23:
                _h.sent();
                return [4 /*yield*/, take([
                        actions.makePayment.type.SUCCESS,
                        actions.makePayment.type.FAILED,
                    ])];
            case 24:
                makePaymentResp = _h.sent();
                if (!(makePaymentResp.type === actions.makePayment.type.FAILED)) return [3 /*break*/, 26];
                return [4 /*yield*/, call(callApi.deleteTrip, { id: resPickup_1.data.createTrip.id })];
            case 25:
                _h.sent();
                throw new Error(makePaymentResp.payload);
            case 26: return [4 /*yield*/, call(callApi.confirmTrip, { id: resPickup_1.data.createTrip.id })];
            case 27:
                _h.sent();
                return [4 /*yield*/, put({
                        type: actions.schedulePickup.type.SUCCESS,
                        payload: __assign(__assign({}, resPickup_1.data.createTrip), { packages: packages.map(function (p) { var _a; return (__assign({}, (_a = p.data) === null || _a === void 0 ? void 0 : _a.createPackage)); }) }),
                    })];
            case 28:
                _h.sent();
                next(true);
                if (!shouldRefreshUser) return [3 /*break*/, 30];
                return [4 /*yield*/, put({
                        type: actions.refresh.type.REQUEST,
                    })];
            case 29:
                _h.sent();
                _h.label = 30;
            case 30: return [2 /*return*/];
            case 31: return [3 /*break*/, 34];
            case 32:
                err_1 = _h.sent();
                message = err_1.message;
                console.error('schedulePickup', message);
                next(false, message || 'Something went wrong, try aging later');
                return [4 /*yield*/, put({
                        type: actions.schedulePickup.type.FAILED,
                    })];
            case 33:
                _h.sent();
                return [3 /*break*/, 34];
            case 34: return [2 /*return*/];
        }
    });
}
export var getHolidays = sagaFactory('holidays', actions.getHolidays, callApi.holidays, 'holidays');
export var getHolidaysAndSetToStore = sagaFactory('getHolidaysAndSetToStore', actions.getHolidaysAndSetToStore, callApi.holidays, 'holidays');
export var updateTripCSAT = sagaFactory('updateTripCSAT', actions.updateTripCSAT, callApi.updateTripCSAT, 'updateTripCSAT');
function pickupSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(actions.schedulePickup.type.REQUEST, schedulePickup)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getHolidays.type.REQUEST, getHolidays)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.getHolidaysAndSetToStore.type.REQUEST, getHolidaysAndSetToStore)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.updateTripCSAT.type.REQUEST, updateTripCSAT)];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default pickupSaga;
//# sourceMappingURL=pickup.js.map